import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';

interface MaskUnmaskIconProps {
    receiveData: Function,
    masked: boolean,
    setMasked: Function
}

const MaskUnmaskIcon = (props: MaskUnmaskIconProps): React.ReactNode | null => {

    const { receiveData, masked, setMasked } = props;
    const dispatch = useAppDispatch();
    const { ssapUnmaskPiiEnabled } = useAppSelector(environmentSelector);
    const [isDataloaded, setDataLoaded] = useState(true);
    const maskUnmaskValue = () => {
        if (masked) {
            setDataLoaded(false);
            dispatch(receiveData({ togglePageReadiness: setDataLoaded }));
        }
        setMasked(!masked);
    };
    const maskValueOnBlur = () => {
        if (!masked) {
            setMasked(true);
        }
    };

    return ssapUnmaskPiiEnabled
        ? <FontAwesomeIcon
            icon={!isDataloaded ? faSpinner : masked ? faEye : faEyeSlash}
            spin={!isDataloaded}
            onClick={maskUnmaskValue}
            onBlur={maskValueOnBlur}
            className="pointer ml-3"
            tabIndex={-1}
            aria-hidden={false}
            data-testid="mask-unmask-icon"
            aria-label={masked ? 'Masked' : 'Unmasked'}
        />
        : null;
};

export default MaskUnmaskIcon;